import React from 'react'

import { Link, Text } from '@factorialco/deprecated-design-system'
import { BookkeepersManagementValueObjectsIncidenceRuleEnforcementEnum } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { mandatoryFieldsTranslations } from 'modules/bookkeepers/lib/dynamicTranslations'
import IncidenceRule, { CATEGORIES } from 'modules/bookkeepers/store/models/IncidenceRule'
import type { MandatoryFieldName } from 'modules/bookkeepers/store/models/IncidenceRule'

interface Props {
  missingField: {
    field: string
    severity: BookkeepersManagementValueObjectsIncidenceRuleEnforcementEnum
  }
  employeeId: string
  contractVersionId?: string
}

const MissingField = ({ missingField, employeeId, contractVersionId }: Props) => {
  const mandatoryFieldsByCategory = IncidenceRule.MandatoryFieldsByCategory()

  const { navigation } = useNavigation()
  const fieldTranslation = mandatoryFieldsTranslations(missingField.field)

  const isValidMandatoryField = (field: string): field is MandatoryFieldName => {
    return field in mandatoryFieldsByCategory
  }

  const category = isValidMandatoryField(missingField.field)
    ? mandatoryFieldsByCategory[missingField.field]
    : undefined

  let missingDataUrl
  if (!category) {
    missingDataUrl = null
  } else {
    switch (category) {
      case CATEGORIES.personal:
        missingDataUrl = employeeId
          ? navigation.employees.id.personal.fullPath({ id: employeeId })
          : ''
        break
      case CATEGORIES.profile:
        missingDataUrl = employeeId ? navigation.employees.id.fullPath({ id: employeeId }) : ''
        break
      case CATEGORIES.contract:
        missingDataUrl =
          employeeId && contractVersionId
            ? navigation.employees.id.contractVersions.contractVersionId.fullPath({
                id: employeeId,
                contractVersionId,
              })
            : ''
    }
  }

  return (
    <li key={missingField.field}>
      <Text.Normal weight="semibold" color="grey1000" size="200">
        {missingDataUrl ? (
          <Link.Href href={missingDataUrl} target="_blank">
            {fieldTranslation}
          </Link.Href>
        ) : (
          fieldTranslation
        )}
      </Text.Normal>
    </li>
  )
}

export default MissingField
